<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>播主认证</span>
        <span class="title_top_hr_tip">
          完善以下资料并通过认证，就可以开直播啦！（认证通过后，资料不可修改，平台会保护你的个人信息！）
        </span>
      </p>
      <el-divider></el-divider>
    </div>
    <div class="anchor_box">
      <el-steps class="user_authentication_step" :active="stepActive" :process-status="processStatus" finish-status="success">
        <el-step title="实名认证"></el-step>
        <el-step title="播主认证"></el-step>
        <el-step title="审核状态"></el-step>
        <el-step title="审核结果"></el-step>
      </el-steps>
      <!-- 未进行实名认证 -->
      <div v-if="examine.type === 0 && personalReview === 0" class="user_review_box">
        <img src="../../assets/img/authentication/personalReviewNone.png" alt="未实名认证">
        <dl class="user_review_tip">
          <dt>请您先通过实名认证！</dt>
          <dd>
          </dd>
        </dl>
        <button class="my_follow_btn user_review_btn" @click="personalClick()">点击前往</button>
      </div>
      <!-- 未审核 -->
      <dl v-if="examine.type === 0 && personalReview === 2" class="anchor_info">
        <dt><img src="../../assets/img/authentication/anchorReview.png" alt="App下载图片"></dt>
        <dd>
          <p>电脑端暂未开通播主认证</p>
          <p>请下载APP进行认证！</p>
        </dd>
      </dl>
      <!-- 审核中 -->
      <!-- <div v-if="examine.type === 1" class="user_review_box">
        <img src="../../assets/img/authentication/anchorReviewWait.png" alt="审核中">
        <dl class="user_review_tip">
          <dt>您提交的播主信息正在审核中...</dt>
          <dd>
            <p>预计一个工作日内完成审核，请耐心等待！</p>
          </dd>
        </dl>
      </div> -->
      <!-- 审核成功 -->
      <div v-if="examine.type === 1" class="user_review_box">
        <img src="../../assets/img/authentication/anchorReviewSuccess.png" alt="认证通过">
        <dl class="user_review_tip">
          <dt>您的播主认证已经通过！</dt>
          <dd>
          </dd>
        </dl>
        <button class="my_follow_btn user_review_btn" @click="liveJump()">开始直播</button>
      </div>
      <!-- 审核失败 -->
      <!-- <div v-if="examine.type === 3" class="user_review_box">
        <img src="../../assets/img/authentication/anchorReviewError.png" alt="认证失败">
        <dl class="user_review_tip">
          <dt>您的播主认证未通过！</dt>
          <dd>
          </dd>
        </dl>
        <button class="my_follow_btn user_review_btn" @click="resetClick()">重新认证</button>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      authenticationLoading: true, // 认证加载动画
      stepActive: 0, // 步骤条当前显示步骤
      processStatus: 'finish', // 当前步骤的状态
      personalReview: 0, // 实名认证是否认证完成
      examine: { // 审核状态
        type: 0,
        text: ''
      },
      info: {
        type: 4
      }
    }
  },
  created () {
    this.getAuthenticationLog()
  },
  methods: {
    // 获取认证信息
    getAuthenticationLog () {
      const vueThat = this
      vueThat.myApi.getAuthenticationLog({ type: vueThat.info.type }).then((res) => {
        if (res.data.code === 200) {
          vueThat.authenticationLoading = false
          vueThat.personalReview = res.data.data.is_auth
          // 判断是否进行实名认证
          if (vueThat.personalReview === 2) { // 实名认证通过
            vueThat.stepActive = 1 // 进入下一步
          } else { // 不通过
            vueThat.stepActive = 0 // 保持第一步
          }
          if (res.data.data.data.status === 0) { // 未进行认证
            vueThat.processStatus = 'finish'
          } else {
            vueThat.examine.type = res.data.data.data.status
            if (res.data.data.data.status === 1) { // 审核成功
              vueThat.stepActive = 3
              vueThat.processStatus = 'success'
            }
          }
        }
      })
    },
    // 跳转实名认证
    personalClick () {
      this.$store.commit('editPersonalMeunAct', 'personalCertification')
      this.$router.push({ path: '/personalCertification' })
    },
    // 跳转发布直播页面
    liveJump () {
      const routeData = this.$router.resolve({
        path: '/liveApply'
      })
      window.open(routeData.href, '_blank')
    },
    // 重置信息提交申请
    resetClick () {
      const vueThat = this
      vueThat.examine.type = 0
      vueThat.stepActive = 1
      vueThat.processStatus = 'finish'
    }
  }
}
</script>

<style>

</style>
